import { Button, Modal } from '@lego/connect-components-react';
import type { RefObject } from 'react';
import { useTranslation } from 'react-i18next';
import type { ConfirmDialogState, GroupSelection, OperatorAccessEntry } from './types';

export const ConfirmDialog = ({
  dialog,
  isBusy,
  triggerRef,
  onClose,
  onRemoveMember,
  onDeleteGroup,
}: {
  dialog: ConfirmDialogState;
  isBusy: boolean;
  triggerRef: RefObject<HTMLElement | null>;
  onClose: () => void;
  onRemoveMember: (entry: OperatorAccessEntry) => Promise<void>;
  onDeleteGroup: (selection: GroupSelection) => Promise<void>;
}) => {
  const { t } = useTranslation();
  const deleting = dialog?.type === 'deleteGroup';
  const confirm = () => {
    if (dialog?.type === 'deleteGroup') {
      void onDeleteGroup(dialog.selection);
    } else if (dialog?.type === 'removeMember') {
      void onRemoveMember(dialog.entry);
    }
  };

  return (
    <Modal
      isOpen={dialog !== null}
      onClose={() => {
        if (!isBusy) onClose();
      }}
      triggerRef={triggerRef}
      size="small"
    >
      <Modal.Title>
        {t(deleting ? 'operatorAccessPage.action.deleteGroup' : 'operatorAccessPage.action.remove')}
      </Modal.Title>
      <Modal.Content>
        <p className="text-body-sm text-core-slate-1100">
          {t(
            deleting
              ? 'operatorAccessPage.response.confirmDeleteGroup'
              : 'operatorAccessPage.response.confirmRemoveMember'
          )}
        </p>
      </Modal.Content>
      <Modal.Footer>
        <Button variant="neutral" size="small" onClick={onClose} disabled={isBusy}>
          {t('operatorAccessPage.action.cancel')}
        </Button>
        <Button variant="negative" size="small" disabled={isBusy} onClick={confirm}>
          {t(
            deleting ? 'operatorAccessPage.action.deleteGroup' : 'operatorAccessPage.action.remove'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
